import { format, startOfDay, sub } from "date-fns";

/**
 * Inclusive [startStr, endStr] in YYYY-MM-DD for "Past N days" presets.
 * End is yesterday (local calendar) so each day aligns with Google Ads-style
 * reporting that excludes incomplete "today". Uses startOfDay everywhere so
 * long ranges (e.g. 90 days) are not skewed by mixing UTC midnight with local DST.
 */
export function getTimeframeDateStringBounds(
  timeFrame: string
): { startStr: string; endStr: string } | null {
  if (timeFrame === "All time") {
    return null;
  }

  const lastFullDay = startOfDay(sub(startOfDay(new Date()), { days: 1 }));
  const endStr = format(lastFullDay, "yyyy-MM-dd");
  let startStr: string;

  switch (timeFrame) {
    case "Past 7 days":
      startStr = format(sub(lastFullDay, { days: 6 }), "yyyy-MM-dd");
      break;
    case "Past 30 days":
      startStr = format(sub(lastFullDay, { days: 29 }), "yyyy-MM-dd");
      break;
    case "Past 90 days":
      startStr = format(sub(lastFullDay, { days: 89 }), "yyyy-MM-dd");
      break;
    case "Past year":
      startStr = format(sub(lastFullDay, { years: 1 }), "yyyy-MM-dd");
      break;
    default:
      return null;
  }

  return { startStr, endStr };
}
